import { ViewIds } from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import {
  isDropdownConfig,
  isToggleConfig,
  type DropdownConfig,
  type SettingsConfig,
  type ToggleConfig,
} from '@ardoq/view-settings';
import { isViewpointModeBubbleChartSettingsControlsDependencies } from './settingsControls';

export type BubbleChartViewSettingsRowsByRole = {
  sourceOfBubbles: DropdownConfig;
  valueSource: DropdownConfig;
  axisFields: DropdownConfig[];
  showZeroSizeBubbles: ToggleConfig;
  layout: DropdownConfig;
};

const AXIS_FIELD_IDS = [
  'selectedFieldNameX',
  'selectedFieldNameY',
  'selectedFieldNameRadius',
];

export const toBubbleChartViewSettingsRows = (
  viewId: ViewIds,
  viewProperties: Record<string, unknown>,
  viewModifiers: SettingsConfig[]
): BubbleChartViewSettingsRowsByRole | null => {
  if (
    viewId !== ViewIds.BUBBLE ||
    !isViewpointModeBubbleChartSettingsControlsDependencies(viewProperties) ||
    !viewProperties.hasReferenceBubbleChartFeature ||
    !viewProperties.sources
  ) {
    return null;
  }

  const viewModifiersById = new Map(
    viewModifiers.map(viewModifier => [viewModifier.id, viewModifier])
  );
  const sourceOfBubbles = viewModifiersById.get('selectedComponentTypes');
  const valueSource = viewModifiersById.get('valueSource');
  const showZeroSizeBubbles = viewModifiersById.get('showBubblesWithZeroValue');
  const layout = viewModifiersById.get('showBackground');

  if (!sourceOfBubbles || !valueSource || !showZeroSizeBubbles || !layout) {
    return null;
  }

  if (
    !isDropdownConfig(sourceOfBubbles) ||
    !isDropdownConfig(valueSource) ||
    !isDropdownConfig(layout)
  ) {
    return null;
  }

  if (!isToggleConfig(showZeroSizeBubbles)) {
    return null;
  }

  return {
    sourceOfBubbles,
    valueSource,
    axisFields: AXIS_FIELD_IDS.map(id => viewModifiersById.get(id))
      .filter(isTruthy)
      .filter(isDropdownConfig),
    showZeroSizeBubbles,
    layout,
  };
};
